import MalariaProphylaxis from "@img/orders/Color=darkblue, Size=1x, Patch=False.png";
import NauseaPrevention from "@img/orders/Color=gray, Size=0.2x, Patch=False.png";
import UrinaryTractInfection from "@img/orders/Color=lavender, Size=0.1x, Patch=False.png";
import RunwayPlus from "@img/orders/Color=lightblue, Size=0.2x, Patch=False.png";
import MotionSickness from "@img/orders/Color=lightblue, Size=0.2x, Patch=True.png";
import AltitudeSickness from "@img/orders/Color=lightgreen, Size=0.2x, Patch=False.png";
import VaginalYeastInfection from "@img/orders/Color=pink, Size=0.1x, Patch=False.png";
import TravelDiarrhea from "@img/orders/Color=teal, Size=0.1x, Patch=False.png";
import TyphoidFever from "@img/orders/Color=vivotif, Size=1x, Patch=False.png";
import Insomnia from "@img/orders/Color=yellow, Size=0.1x, Patch=False-1.png";
import LymeDisease from "@img/orders/Color=berry, Size=1x, Patch=False.webp";
import Influenza from "@img/orders/Color=medgray, Size=1x, Patch=False.webp";
import { ConditionTypes } from "@types-runway/condition";

const productImages = {
  [ConditionTypes.ALTITUDE_CONSULTATION]: AltitudeSickness,
  [ConditionTypes.MALARIA_CONSULTATION]: MalariaProphylaxis,
  [ConditionTypes.MOTION_CONSULTATION]: MotionSickness,
  [ConditionTypes.NAUSEA_CONSULTATION]: NauseaPrevention,
  [ConditionTypes.RUNWAY_PLUS]: RunwayPlus,
  [ConditionTypes.INSOMNIA_CONSULTATION]: Insomnia,
  [ConditionTypes.DIARRHEA_CONSULTATION]: TravelDiarrhea,
  [ConditionTypes.TYPHOID_FEVER]: TyphoidFever,
  [ConditionTypes.URINARY_TRACT_INFECTION]: UrinaryTractInfection,
  [ConditionTypes.VAGINAL_YEAST_INFECTION]: VaginalYeastInfection,
  [ConditionTypes.ANAPHYLAXIS]: NauseaPrevention,
  [ConditionTypes.SKIN_INFECTION]: UrinaryTractInfection,
  [ConditionTypes.LYME_DISEASE_CONSULTATION]: LymeDisease,
  [ConditionTypes.INFLUENZA_CONSULTATION]: Influenza,
};

export const getProductImage = (condition: ConditionTypes) => {
  return productImages[condition] || productImages[ConditionTypes.RUNWAY_PLUS];
};
